import { useCallback } from 'react';
import { sdk } from 'sdk';
import { GetContentTypeByPagination } from 'sdk/composable-commerce/types/queries/AmplienceQueries';

const useAmplience = () => {
  const getContentByDeliveryKey = useCallback(async (deliveryKey: string) => {
    const extensions = sdk.composableCommerce;
    const res = await extensions.amplience.getContentByDeliveryKey(deliveryKey);

    return res.isError ? {} : res.data;
  }, []);

  const getContentListByContentType = useCallback(async (query: GetContentTypeByPagination) => {
    const extensions = sdk.composableCommerce;
    const res = await extensions.amplience.getContentListByContentType(query);

    return res.isError ? {} : res.data;
  }, []);

  return {
    getContentByDeliveryKey,
    getContentListByContentType,
  };
};

export default useAmplience;
